export const MENU_PROTOTYPE_ICON_IDS = [
  'profile',
  'requisites',
  'notifications',
  'integrations',
  'applications',
  'online-consultations',
  'reviews',
  'showcase',
  'orders',
  'referral-program',
] as const

export type MenuPrototypeIconId = (typeof MENU_PROTOTYPE_ICON_IDS)[number]

export function isMenuPrototypeIcon(icon?: string): icon is MenuPrototypeIconId {
  return MENU_PROTOTYPE_ICON_IDS.includes(icon as MenuPrototypeIconId)
}
